import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { useStore } from '../../../../../../contexts/StoreContext';
import useSelectedProductSku from './hooks/useSelectedProductSku';
import useStoreAvailabilities from './hooks/useStoreAvailabilities';

const StoreContext = createContext();

export function StoreProvider({ children, currentAttributeState }) {
  const { selectedStore } = useStore();

  const [stores, setStores] = useState(() => (selectedStore ? [selectedStore] : []));

  const selectedSku = useSelectedProductSku(currentAttributeState);
  const availabilities = useStoreAvailabilities(stores);

  const value = {
    availabilities,
    selectedSku,
    selectedStore,
    stores,
    setStores,
  };

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}

export function useStoreContext() {
  return useContext(StoreContext);
}
